import React from 'react'
import PropTypes from 'prop-types'
import { useModal } from './Modal'
import { Icon } from '../../atoms'

export default function ModalHeader({ children, title }) {
  const modalContext = useModal()
  const { title: contextTitle, hasCloseButton } = modalContext || {}

  if (!modalContext) return null
  const finalTitle = title || children || contextTitle
  const shouldRenderTitle = Boolean(finalTitle)

  return (
    <div className="modal-lite__content-header">
      {shouldRenderTitle && <h3 className="modal-lite__title">{finalTitle}</h3>}
      {hasCloseButton && (
        <span className="modal-lite__close" data-modal-close>
          <Icon className="icon--large" name="cross" />
        </span>
      )}
    </div>
  )
}

ModalHeader.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string
}

ModalHeader.defaultProps = {}
